import { render, staticRenderFns } from "./CabinetEventsTable.vue?vue&type=template&id=4644c6ca"
import script from "./CabinetEventsTable.vue?vue&type=script&lang=ts"
export * from "./CabinetEventsTable.vue?vue&type=script&lang=ts"
import style0 from "./CabinetEventsTable.vue?vue&type=style&index=0&id=4644c6ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports